import { editorRoleFor } from "@msuite/citadel";
import { useCitadel } from "@/hooks/use-citadel";

/**
 * Which side of the absence editability rule the caller stands on — the same question the
 * server answers before it writes: `"admin"` when the caller's `update Absence` carries no
 * condition (the owner and the admin role), who may change any absence; `"user"` for everybody
 * whose right is bound to their own rows, who may change their own vacation request only while
 * it has not started. Fed to `getIsAbsenceEditable`, so the controls hide exactly what the
 * server would refuse. While the rules are still loading the answer is `"user"`, the narrower
 * of the two.
 */
export function useAbsenceEditorRole(): "admin" | "user" {
	const { citadel } = useCitadel();
	return editorRoleFor(citadel, "Absence");
}
